import React, { useEffect, useState } from 'react'
import MaterialTable from 'material-table';
import { useSelector } from 'react-redux';

import { dataAxureFetch } from '../../../helpers/fetch';





export const AnnouncersTable = () => {

    const uid = useSelector((state) => state.auth.uid);

    const [points, setPoints] = useState([]);

    useEffect(() => {
        getPoints();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const getPoints = async () => {
        try {
            const newPoints = await dataAxureFetch({solicitud:"Anunciadores",idCliente:uid},'POST');
            if(newPoints){
                setPoints(newPoints);
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <MaterialTable
                columns = {[
                    {field: 'id', title: 'Identificador'},
                    {field: 'nombre', title: 'Nombre'},
                    {field: 'nivel', title: 'Nivel Alerta'},
                    {field: 'latitud', title: 'Latitud'},
                    {field: 'longitud', title: 'Longitud'},
                    {field: 'estado', title: 'Estado'},
                ]}
                data = {points}
                options={{ 
                    padding: 'dense',
                    pageSize: 10,
                }}
                title="Anunciadores"
            />
        </>
    )
}
